<template>
  <div class="order-detail-page full-height display-col">
    <full-con :canReturn="canReturn">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/orderList' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/orderList' }">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item v-if="isEditPage">编辑订单</el-breadcrumb-item>
        <el-breadcrumb-item >订单详情</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="full">
        <div class="order-detail-container full-height flex1">
          <el-form :model="orderInfo" ref="addForm" :rules="addFormInfo">
            <div class="tabel-container tabel-container-top" v-if="!isEditPage">
              <div class="table-title">
                {{ $t("OrderDetail.OrderDetail1") }}
              </div>
              <el-row class="table-content">
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail50") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.orderId }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail2") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.orderCreateTime | dateFormatToSecond
                      }}</el-col>
                  </el-row>
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail3')}}：</el-col>
                                        <el-col :span="14">{{ orderInfo.tongkun }}</el-col>
                                    </el-row> -->
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail4") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.badCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("orderList.orderList30") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.waitBoxCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("orderList.orderList130") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.netWeight }}</el-col>
                  </el-row>
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail5')}}：</el-col>
                                        <el-col :span="14">
                                            <el-select v-if="false" v-model="orderInfo.cartonSizeId" :placeholder="$t('goods.goods21')" size="small" clearable>
                                                <el-option v-for="(item,index) in configLists.boxConfigList" :key="index" :label="item.name" :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <span>{{orderInfo.cartonSizeId}}</span>
                                        </el-col>
                                    </el-row> -->
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail6')}}：</el-col>
                                        <el-col :span="14">
                                            <el-select v-if="false" v-model="orderInfo.oppTypeId" :placeholder="$t('goods.goods21')" size="small" clearable>
                                                <el-option v-for="(item,index) in configLists.oppConfigList" :key="index" :label="item.name" :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <span>{{orderInfo.oppTypeId}}</span>
                                        </el-col>
                                    </el-row> -->
                </el-col>
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail7") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.receiveTime | dateFormatToSecond
                      }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail8") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.exchangCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("orderList.orderList48") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.refundCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail9')}}：</el-col>
                                        <el-col :span="14" class="ipt-container">
                                            <el-form-item v-if="false">
                                                <el-input size="small" disabled v-model="orderInfo.throwWeight"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.throwWeight }}</span>
                                        </el-col>
                                    </el-row> -->
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail10')}}：</el-col>
                                        <el-col :span="14">
                                            <el-form-item v-if="false">
                                                <el-input size="small" disabled v-model="orderInfo.oppCount"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.oppCount }}</span>
                                        </el-col>
                                    </el-row> -->
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('orderList.orderList4')}}：</el-col>
                                        <el-col :span="14">
                                            <el-form-item v-if="false">
                                                <el-input size="small" v-model="orderInfo.trackingNumberJpn"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.trackingNumberJpn }}</span>
                                        </el-col>
                                    </el-row> -->
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('wzbg.wz7')}}：</el-col>
                                        <el-col :span="14">
                                            <el-select :disabled='goodsEditFlag' v-model="orderInfo.configLogisticsCompanyId" :placeholder="$t('goods.goods21')" size="small" clearable>
                                                <el-option v-for="(item,index) in configLists.logisticsCompanyConfigList" :key="index" :label="item.name" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row> -->
                </el-col>
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10">{{ $t("orderList.orderList46") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.orderStatus | orderStatusFilter
                      }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail11") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.sendTime | dateFormatToSecond
                      }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail12") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.reissueCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("orderList.orderList49") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.destroyCount }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail13')}}：</el-col>
                                        <el-col :span="14">
                                            <el-form-item v-if="false">
                                                <el-input size="small" v-model="orderInfo.realWeight"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.realWeight }}</span>
                                        </el-col>
                                    </el-row> -->
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail14')}}：</el-col>
                                        <el-col :span="14">{{ orderInfo.sagawaState }}</el-col>
                                    </el-row> -->
                </el-col>
              </el-row>
            </div>
            <div class="tabel-container">
              <div class="table-title">
                {{ $t("createOrder.createOrder13") }}
              </div>
              <el-row class="table-content">
                <el-col :span="8" class="content nomove">
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail17") }}：</el-col>
                    <el-col :span="14" class="hbOneStr">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input :disabled="goodsEditFlag" :style="{
                          width: addFormInfo.goodsName[0].required
                            ? '90%!important'
                            : '98%!important',
                        }" size="small" v-model="orderInfo.taobaoUrl"></el-input>
                      </el-form-item>
                      <el-tooltip v-else effect="light" placement="top-start">
                        <div class="zcl-tooltip-width" slot="content" v-html="orderInfo.taobaoUrl">
                        </div>
                        <span class="hbOneStr" >{{ orderInfo.taobaoUrl }}</span>
                      </el-tooltip>
                      <!--<el-tooltip v-else :content="orderInfo.taobaoUrl" placement="top" effect="light">
                        <span class="hbOneStr" >{{ orderInfo.taobaoUrl }}</span>
                      </el-tooltip>-->
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.colour[0].required">*</font>
                      {{ $t("orderList.orderList26") }}：
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item prop="colour" v-if="editGoodsInfo">
                        <el-input :disabled="goodsEditFlag" :style="{
                          width: addFormInfo.colour[0].required
                            ? '50%!important'
                            : '100%',
                        }" size="small" v-model="orderInfo.colour"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.colour }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("createOrder.createOrder21") }}：</el-col>
                    <el-col :span="14">
                      <el-select :disabled="goodsEditFlag" v-if="editOrderInfoAccountNumber" v-model="orderInfo.agentFlag"
                                 :placeholder="$t('goods.goods21')" size="small" clearable :style="{
                          width: addFormInfo.goodsName[0].required
                            ? '90%!important'
                            : '92%!important',
                        }" @change="isAgentChange(orderInfo.agentFlag)">
                        <el-option v-for="(item, index) in loadBoxOptions" :key="index" :label="item.name"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else v-model="orderInfo.agentFlag" :placeholder="$t('goods.goods21')" size="small"
                                 disabled @change="isAgentChange(orderInfo.agentFlag)">
                        <el-option v-for="(item, index) in loadBoxOptions" :key="index" :label="item.name"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.goodsCount[0].required">*</font>
                      {{ $t("createOrder.createOrder38") }}
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item prop="goodsCount" v-if="editGoodsInfo">
                        <el-input :disabled="goodsEditFlag" style="width: 50% !important" size="small"
                                  v-model="orderInfo.goodsCount"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsCount }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("createOrder.createOrder23") }}：</el-col>
                    <el-col :span="14">
                      <el-select :disabled="goodsEditFlag" v-if="editGoodsInfo" v-model="orderInfo.orderType"
                                 :placeholder="$t('goods.goods21')" size="small" clearable
                                 @change="isFbaChange(orderInfo.orderType)" :style="{
                          width: addFormInfo.goodsName[0].required
                            ? '90%!important'
                            : '92%!important',
                        }">
                        <el-option v-for="(item, index) in fbaOptions" :key="index" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else v-model="orderInfo.orderType" :placeholder="$t('goods.goods21')" size="small"
                                 disabled @change="isFbaChange(orderInfo.orderType)">
                        <el-option v-for="(item, index) in fbaOptions" :key="index" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">ASIN：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input :disabled="goodsEditFlag" :style="{
                          width: addFormInfo.goodsName[0].required
                            ? '90%!important'
                            : '98%!important',
                        }" size="small" v-model="orderInfo.asin"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.asin }}</span>
                    </el-col>
                  </el-row>
                  <!-- 图片 -->
                  <el-row>
                    <el-col style="height: 78px;" :span="10">{{ $t("OrderDetail.OrderDetail54") }}：</el-col>
                    <el-col :span="14" style="line-height: 15px; display: flex;height: 78px;">
                      <my-upload v-model="orderInfo.pictureUrl" :disabled="!editGoodsInfo"   size="mini" :limit="1" accept=".png,.jpg,.jpeg"  />
                      <!-- <img @click="imgclick" v-if="orderInfo.pictureUrl &&
                        orderInfo.pictureUrl.length > 0
                        " :src="orderInfo.pictureUrl" alt="" style="width: 35px; height: 35px" />
                      <el-upload class="avatar-uploader" action="/" :show-file-list="false" :http-request="uploadImg"
                        accept="image/png,image/jpeg" :limit="1">
                        <el-button v-if="editGoodsInfo && !orderInfo.pictureUrl" class="list-btn btn-blue bt"
                          ref="uploadImg">
                          {{ $t("createOrder.createOrder20") }}</el-button>
                      </el-upload>
                      <el-button @click="delImg" v-if="editGoodsInfo &&
                        orderInfo.pictureUrl &&
                        orderInfo.pictureUrl.length > 0
                        " class="list-btn btn-red btnn">{{ $t("delete") }}
                      </el-button> -->
                      <!-- <el-form-item v-if="editGoodsInfo">
                                          <el-input :disabled='goodsEditFlag' size="small" v-model="orderInfo.pictureUrl"></el-input>
                                      </el-form-item>
                                      <span v-else @click="imgView(orderInfo.pictureUrl)" class="can-click">{{ orderInfo.pictureUrl }}</span> -->
                    </el-col>
                  </el-row>
                  <el-row style="height: 160px;">
                    <el-col style="height: 160px;" :span="10">{{ $t("createOrder.createOrder22") }}：</el-col>
                    <el-col style="height: 160px;" :span="14">
                      <my-upload v-model="orderInfo.pdfAttachment" :disabled="!editGoodsInfo"
                                 size="mini" isJson isDelInfo mode="array" :keyObject="{ url: 'url', name: 'name' }" :limit="5"
                                 listType="text"  >
                        <el-button class="list-btn btn-blue">
                          {{ $t("createOrder.createOrder20") }}</el-button>
                      </my-upload>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8" class="content l90">
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.goodsName[0].required">*</font>
                      {{ $t("OrderDetail.OrderDetail51") }}：
                    </el-col>
                    <el-col :span="14" class="hbOneStr">
                      <el-form-item v-if="editGoodsInfo" prop="goodsName">
                        <el-input :disabled="goodsEditFlag" :style="{
                          width: addFormInfo.goodsName[0].required
                            ? '90%!important'
                            : '98%!important',
                        }" size="small" v-model="orderInfo.goodsName"></el-input>
                      </el-form-item>
                      <el-tooltip v-else :content="orderInfo.goodsName" placement="top" effect="light">
                        <span class="hbOneStr" >{{ orderInfo.goodsName }}</span>
                      </el-tooltip>
                      <!--<span v-else>{{ orderInfo.goodsName }}</span>-->
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.goodsSize[0].required">*</font>
                      {{ $t("orderList.orderList27") }}：
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item prop="goodsSize" v-if="editGoodsInfo">
                        <el-input :disabled="goodsEditFlag" size="small" style="width: 50% !important"
                                  v-model="orderInfo.goodsSize"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsSize }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.price[0].required">*</font>
                      {{ $t("createOrder.createOrder37") }}
                    </el-col>
                    <el-col :span="14" class="hidden">
                      <el-form-item prop="price" v-if="editGoodsInfo">
                        <!-- <el-input :disabled="goodsEditFlag" style="width: 50% !important" size="small"
                                  v-model="orderInfo.price">
                        </el-input> -->
                        <PriceInput
                          style="width: 50% !important"
                          size="small"
                          v-model="orderInfo.price"
                          :disabled="goodsEditFlag"
                        ></PriceInput>
                      </el-form-item>
                      <span v-else>{{ orderInfo.price }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.fnsku[0].required">*</font>
                      {{
                        addFormInfo.skuLabel ? addFormInfo.skuLabel : "バーコード"
                      }}：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item prop="fnsku" v-if="editGoodsInfo">
                        <el-input :placeholder="addFormInfo.skuPlaceolder" :disabled="isFbaDisabled || goodsEditFlag"
                                  :style="{
                            width: addFormInfo.fnsku[0].required
                              ? '90%!important'
                              : '98%!important',
                          }" size="small" v-model="orderInfo.fnsku"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.fnsku }}</span>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="10">{{ $t("createOrder.createOrder27") }}：</el-col>
                    <el-col :span="14">
                      <el-select :disabled="goodsEditFlag" v-if="editGoodsInfo" v-model="orderInfo.putIntent"
                                 :placeholder="$t('goods.goods21')" size="small" clearable :style="{
                          width: addFormInfo.goodsName[0].required
                            ? '92%!important'
                            : '100%!important',
                        }">
                        <el-option v-for="(item, index) in putIntentOption" :key="index" :label="item.name"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else v-model="orderInfo.putIntent" :placeholder="$t('goods.goods21')" size="small"
                                 disabled>
                        <el-option v-for="(item, index) in putIntentOption" :key="index" :label="item.name"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="10">{{ $t("createOrder.createOrder26") }}：</el-col>
                    <el-col :span="14">
                      <el-form-item prop="laundryLabelId" v-if="editGoodsInfo">
                        <el-select v-model="orderInfo.laundryLabelId" :placeholder="$t('goods.goods21')" size="small"
                                   clearable :style="{
                            width: addFormInfo.laundryLabelId[0].required
                              ? '92%!important'
                              : '100%!important',
                          }" :disabled="isDisabled || goodsEditFlag">
                          <el-option v-for="(item, index) in this.laundryLabelOption" :key="index" :label="item.name"
                                     :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-select v-else v-model="orderInfo.laundryLabelId" :placeholder="$t('goods.goods21')" size="small"
                                 disabled>
                        <el-option v-for="(item, index) in this.laundryLabelOption" :key="index" :label="item.name"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="height: 78px;" :span="10">{{ $t("OrderDetail.OrderDetail53") }}：</el-col>
                    <el-col style="height: 78px;" :span="14">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input :disabled="goodsEditFlag" size="small" v-model="orderInfo.customerRemark"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.customerRemark }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="height: 160px;" :span="10"></el-col>
                    <el-col style="height: 160px;" :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col :span="8" class="content">

                  <el-row>
                    <el-col :span="10">{{ $t("orderList.orderList28") }}：</el-col>
                    <el-col :span="14">
                      <el-form-item v-if="editGoodsInfo">
                        <el-input :disabled="goodsEditFlag" :style="{
                          width: addFormInfo.goodsName[0].required
                            ? '90%!important'
                            : '98%!important',
                        }" size="small" v-model="orderInfo.goodsNumber"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsNumber }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.chineseFreightFee[0].required">*</font>
                      {{ $t("orderList.orderList119") }}：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item prop="chineseFreightFee" v-if="editGoodsInfo">
                        <el-input :disabled="!isAgentDisabled || goodsEditFlag" style="width: 50% !important" size="small"
                                  v-model="orderInfo.chineseFreightFee" type="number"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.chineseFreightFee }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("orderList.orderList175") }}：</el-col>
                    <el-col :span="14">
                      <span v-if="orderInfo.warehouseStorageDays != null &&
                        orderInfo.orderStatus != '52' &&
                        orderInfo.orderStatus != '72' &&
                        orderInfo.orderStatus != '84' &&
                        orderInfo.checkFinishTime != null
                        ">{{ $t("orderList.orderList140")
                        }}{{ orderInfo.warehouseStorageDays }}日</span>
                      <span v-else-if="orderInfo.chargingDays > 0 &&
                        orderInfo.orderStatus != '52' &&
                        orderInfo.orderStatus != '72' &&
                        orderInfo.orderStatus != '84' &&
                        orderInfo.categoryPrice != 0 &&
                        orderInfo.freeWarehousing == '0'
                        ">{{ $t("orderList.orderList141")
                        }}{{ orderInfo.categoryPrice }}元({{
                          $t("orderList.orderList142")
                        }}{{ orderInfo.chargingDays }}日)</span>
                      <span v-else></span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.goodsNameCus[0].required">*</font>
                      {{ $t("OrderDetail.OrderDetail55") }}：
                    </el-col>
                    <el-col :span="14">
                      <el-form-item prop="goodsNameCus" v-if="editGoodsInfo">
                        <el-input :disabled="isFbaDisabled || goodsEditFlag" :style="{
                          width: addFormInfo.goodsNameCus[0].required
                            ? '90%!important'
                            : '98%!important',
                        }" size="small" v-model="orderInfo.goodsNameCus"></el-input>
                      </el-form-item>
                      <span v-else>{{ orderInfo.goodsNameCus }}</span>
                    </el-col>
                  </el-row>
                  <!--检品文件-->
                  <el-row>
                    <el-col :span="10">{{ $t("createOrder.createOrder95") }}：</el-col>
                    <el-col :span="14">
                      <my-upload :disabled="!editGoodsInfo" size="mini" v-model="orderInfo.inspectionFileUrl" :fileName.sync="orderInfo.inspectionFileName" :limit="1" listType="text" >
                        <el-button class="avatar-uploader-icon list-btn btn-blue">{{ $t("createOrder.createOrder20") }}
                        </el-button>
                      </my-upload>
                    </el-col>
                  </el-row>
                  <el-row class="l90">
                    <el-col :span="10">
                      <font color="red" v-show="addFormInfo.trackingNumberCn[0].required">*</font>
                      {{ $t("OrderDetail.OrderDetail52") }}：
                    </el-col>
                    <el-col :span="14" v-if="editGoodsInfo">
                      <!-- <el-form-item  v-if="goodsEditFlag || orderInfo.agentFlag=='1'">
                                                <el-input :disabled='true' :style="{width:(addFormInfo.goodsName[0].required?'88%!important':'90%!important')}" size="small" v-model="orderInfo.trackingNumberCn"></el-input>
                                            </el-form-item>
                                            <el-form-item prop="trackingNumberCn" v-else>
                                                <el-input  :style="{width:(addFormInfo.goodsName[0].required?'88%!important':'90%!important')}" size="small" v-model="orderInfo.trackingNumberCn"></el-input>
                                            </el-form-item> -->
                      <el-form-item prop="trackingNumberCn">
                        <el-input :disabled="isAgentDisabled || goodsEditFlag" :style="{
                          width: addFormInfo.goodsName[0].required
                            ? '88%!important'
                            : '90%!important',
                        }" size="small" v-model="orderInfo.trackingNumberCn"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="14" v-else>
                      <span>{{ orderInfo.trackingNumberCn }}</span>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col style="height: 78px;" :span="10">{{ $t("createOrder.createOrder25") }}：</el-col>
                    <el-col style="height: 78px;" :span="14">
                      <el-select :disabled="goodsEditFlag" multiple v-if="editGoodsInfo"
                                 v-model="orderInfo.configCheckProjectArray" :placeholder="$t('goods.goods21')" size="small"
                                 clearable @change="configCheckChanged()">
                        <el-option v-for="(
                            item, index
                          ) in configLists.inspectionConfigList" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-else multiple v-model="orderInfo.configCheckProjectArray"
                                 :placeholder="$t('goods.goods21')" size="small" disabled>
                        <el-option v-for="(
                            item, index
                          ) in configLists.inspectionConfigList" :key="index" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col style="height: 160px;" :span="10"></el-col>
                    <el-col style="height: 160px;" :span="14"></el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <div class="tabel-container">
              <div class="table-title">{{ $t('OrderDetail.OrderDetail69') }}</div>
              <el-row class="table-content">
                <el-col :span="12" class="content" style="display: flex">
                  <el-col :span="6" style="height: auto; min-height: 37px">{{ $t('OrderDetail.OrderDetail57') }}：</el-col>
                  <el-col :span="18" style="height: auto; min-height: 37px">
                    <div v-if="orderInfo.checkVideoList && orderInfo.checkVideoList.length > 0" style="display: flex; flex-wrap: wrap; gap: 8px">
                      <div v-for="(v, i) in orderInfo.checkVideoList" :key="i">
                        <video :src="v" controls style="width: 200px; height: 160px; object-fit: cover"></video>
                      </div>
                    </div>
                    <span v-else>-</span>
                  </el-col>
                </el-col>
                <el-col :span="12" class="content" style="display: flex">
                  <el-col :span="6" style="height: auto; min-height: 37px">{{ $t('OrderDetail.OrderDetail68') }}：</el-col>
                  <el-col :span="18" style="height: auto; min-height: 37px">
                    <div v-if="orderInfo.checkImageList && orderInfo.checkImageList.length > 0" style="display: flex; flex-wrap: wrap; gap: 8px">
                      <div v-for="(v, i) in orderInfo.checkImageList" :key="i">
                        <img :src="v" style="width: 200px; height: 160px; object-fit: cover; cursor: pointer" @click="imgView(v)" />
                      </div>
                    </div>
                    <span v-else>-</span>
                  </el-col>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="tabel-container">
                            <div class="table-title">{{$t('OrderDetail.OrderDetail18')}}</div>
                            <el-row class="table-content">
                                <el-col :span="6" class=" l87 content">
                                    <el-row>
                                        <el-col :span="10">
                                            <font color="red" v-show="addFormInfo.sender[0].required">*</font>
                                            {{$t('OrderDetail.OrderDetail19')}}：
                                        </el-col>
                                        <el-col :span="14">
                                            <el-form-item prop="sender" v-if="editAddressInfo">
                                                <el-input :style="{width:(addFormInfo.sender[0].required?'85%!important':'98%!important')}" size="small" v-model="orderInfo.sender"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.sender }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10">
                                            <font color="red" v-show="addFormInfo.receiver[0].required">*</font>
                                            {{$t('mail.mailTo')}}：
                                        </el-col>
                                        <el-col :span="14">
                                            <el-form-item prop="receiver" v-if="editAddressInfo">
                                                <el-input :style="{width:(addFormInfo.receiver[0].required?'86%!important':'98%!important')}" size="small" v-model="orderInfo.receiver"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.receiver }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10">
                                            <font color="red" v-show="addFormInfo.zipCode[0].required">*</font>
                                            {{$t('OrderDetail.OrderDetail20')}}：
                                        </el-col>
                                        <el-col :span="14">
                                            <el-form-item prop="zipCode" v-if="editAddressInfo">
                                                <el-input :style="{width:(addFormInfo.zipCode[0].required?'86%!important':'98%!important')}" size="small" v-model="orderInfo.zipCode"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.zipCode }}</span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="6" class=" l87 content">
                                    <el-row>
                                        <el-col :span="10">
                                            <font color="red" v-show="addFormInfo.senderPhone[0].required">*</font>
                                            {{$t('OrderDetail.OrderDetail21')}}：
                                        </el-col>
                                        <el-col :span="14">
                                            <el-form-item prop="senderPhone" v-if="editAddressInfo">
                                                <el-input :style="{width:(addFormInfo.senderPhone[0].required?'86%!important':'98%!important')}" size="small" v-model="orderInfo.senderPhone"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.senderPhone }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10">
                                            <font color="red" v-show="addFormInfo.receiverPhone[0].required">*</font>
                                            {{$t('OrderDetail.OrderDetail22')}}：
                                        </el-col>
                                        <el-col :span="14">
                                            <el-form-item prop="receiverPhone" v-if="editAddressInfo">
                                                <el-input size="small" :style="{width:(addFormInfo.receiverPhone[0].required?'86%!important':'98%!important')}" v-model="orderInfo.receiverPhone"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.receiverPhone }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail23')}}</el-col>
                                        <el-col :span="14">
                                            <span>{{ orderInfo.addressNo }}</span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12" class="content l90">
                                    <el-row>
                                        <el-col :span="10">
                                            <font color="red" v-show="addFormInfo.sendAddress[0].required">*</font>
                                            {{$t('OrderDetail.OrderDetail24')}}：
                                        </el-col>
                                        <el-col :span="14">
                                            <el-form-item prop="sendAddress" v-if="editAddressInfo">
                                                <el-input :style="{width:(addFormInfo.sendAddress[0].required?'90%!important':'98%!important')}" size="small" v-model="orderInfo.sendAddress"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.sendAddress }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10">
                                            <font color="red" v-show="addFormInfo.receiverAddress[0].required">*</font>
                                            {{$t('OrderDetail.OrderDetail25')}}：
                                        </el-col>
                                        <el-col :span="14">
                                            <el-form-item prop="receiverAddress" v-if="editAddressInfo">
                                                <el-input :style="{width:(addFormInfo.receiverAddress[0].required?'90%!important':'98%!important')}" size="small" v-model="orderInfo.receiverAddress"></el-input>
                                            </el-form-item>
                                            <span v-else>{{ orderInfo.receiverAddress }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="10"></el-col>
                                        <el-col :span="14"></el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div> -->

            <!--<div class="tabel-container" v-if="orderInfo.checkVideo != null && orderInfo.checkVideo != ''">-->
            <!--  <div class="table-title">-->
            <!--    {{ $t("OrderDetail.OrderDetail57") }}-->
            <!--  </div>-->
            <!--  <el-row class="check-video">-->
            <!--    <video v-for="video in getVideo(orderInfo.checkVideo)" :src="video" :width="280" :height="150" controls-->
            <!--           controlsList="nodownload noplaybackrate" disablepictureinpicture></video>-->
            <!--  </el-row>-->
            <!--</div>-->

            <div class="tabel-container" v-if="!isEditPage">
              <div class="table-title">
                {{ $t("OrderDetail.OrderDetail26") }}
              </div>
              <el-row class="table-content">
                <el-col :span="5" class="content">
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail47") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.goodsPrice || 0 }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail49") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.problemHandlingFee || 0
                      }}</el-col>
                  </el-row>
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail28')}}：</el-col>
                                        <el-col :span="14">{{ orderInfo.printFee }}</el-col>
                                    </el-row> -->

                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail30") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.totalPrice || 0 }}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="5" class="content">
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail29") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.agentServiceFee || 0
                      }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail32") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.returnFee || 0 }}</el-col>
                  </el-row>
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail31')}}：</el-col>
                                        <el-col :span="14">{{ orderInfo.cartonPrice }}</el-col>
                                    </el-row> -->

                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail33')}}：</el-col>
                                        <el-col :span="14">{{ orderInfo.refundServiceFee }}</el-col>
                                    </el-row> -->
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col :span="5" class="content">
                  <el-row>
                    <el-col :span="10">{{ $t("orderList.orderList119") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.inlandFreight || 0
                      }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail35") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.categoryPrice || 0
                      }}</el-col>
                  </el-row>
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail34')}}：</el-col>
                                        <el-col :span="14">{{ orderInfo.basicInspection }}</el-col>
                                    </el-row> -->

                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail36')}}：</el-col>
                                        <el-col :span="14">{{ orderInfo.destroyServiceFee }}</el-col>
                                    </el-row> -->
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col :span="5" class="content">
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail38") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.inspectionFee || 0
                      }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail58") }}：</el-col>
                    <el-col :span="14">{{
                        orderInfo.exchangeInspectionFee || 0
                      }}</el-col>
                  </el-row>
                  <!-- <el-row>
                                        <el-col :span="10">{{$t('OrderDetail.OrderDetail37')}}：</el-col>
                                        <el-col :span="14">{{ orderInfo.oppFee }}</el-col>
                                    </el-row> -->

                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col :span="4" class="content">
                  <el-row>
                    <el-col :span="10">{{ $t("OrderDetail.OrderDetail39") }}：</el-col>
                    <el-col :span="14">{{ orderInfo.labelFee || 0 }}</el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <div>
              <div class="table-title">{{ $t("OrderDetail.OrderDetail59") }}</div>
              <el-table :data="hisOrderStateLogList" style="width: 100%">
                <el-table-column prop="souceState" :label="$t('OrderDetail.OrderDetail60')">
                </el-table-column>
                <el-table-column prop="targetState" :label="$t('OrderDetail.OrderDetail61')">
                </el-table-column>
                <el-table-column prop="note" :label="$t('OrderDetail.OrderDetail62')">
                </el-table-column>
                <el-table-column prop="content" :label="$t('OrderDetail.OrderDetail63')">
                </el-table-column>
                <el-table-column prop="createTime" :label="$t('OrderDetail.OrderDetail64')">
                  <template #default="{ row }">
                    {{ row.createTime | dateFormatToSecond }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form>
          <div class="save-btn-container" v-if="isEditPage">
            <el-button class="form-btn btn-gray" @click="cancelEditOrder">{{
                $t("cancel")
              }}</el-button>
            <el-button class="form-btn btn-blue" @click="saveEditOrder">{{
                $t("submit")
              }}</el-button>
          </div>
        </div>
      </div>
    </full-con>
    <el-dialog :visible.sync="ShowImg" @close="ShowImg = false" width="35%">
      <div>
        <img :src="showImgUrl" alt="" width="100%" height="auto" />
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="orderInfo.pictureUrl" alt="" class="list-image" />
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
  </div>
</template>

<script>
import PriceInput from "@/components/PriceInput";
import axios from "axios";
import editBreadcrumb from "../../../views/layout/components/editBreadCrumb";
export default {
  data() {
    return {
      isDisabled: true,
      isFbaDisabled: true,
      visible: false,
      isAgentDisabled: true,
      canReturn: "1",
      pageTitle: this.$t("OrderDetail.OrderDetail41"),
      orderId: "",
      customerId: "",
      laundryLabelOption: [],
      hisOrderStateLogList: [], //订单日志
      isEditPage: "0",
      orderInfo: {},
      addFormInfo: {
        goodsCount: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
          {
            pattern: /^[0-9]+$/,
            message: this.$t("OrderDetail.OrderDetail43"),
            trigger: "blur",
          },
        ],
        colour: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        goodsSize: [
          {
            required: false,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
          // {
          //   pattern: /^\d+(\.\d{0,2})?$/,
          //   message: this.$t("OrderDetail.OrderDetail44"),
          //   trigger: "blur",
          // },
        ],
        trackingNumberCn: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        chineseFreightFee: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        fnsku: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
          // {pattern:  /^[0-9]+$/, message: '必填', trigger: 'blur'},
        ],
        goodsNameCus: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        goodsName: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        sender: [
          {
            required: false,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        senderPhone: [
          {
            required: false,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        sendAddress: [
          {
            required: false,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        receiver: [
          {
            required: false,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        receiverPhone: [
          {
            required: false,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        zipCode: [
          {
            required: false,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        receiverAddress: [
          {
            required: false,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
        laundryLabelId: [
          {
            required: true,
            message: this.$t("OrderDetail.OrderDetail42"),
            trigger: "blur",
          },
        ],
      },
      goodsEditFlag: true,
      chinaOrderFlag: true,
      imgurl: "",
      configLists: {
        logisticsCompanyConfigList: [], //快递 id companyName
        inspectionConfigList: [], //标签 nameCd  name
        boxConfigList: [], //装箱
        oppConfigList: [], //opp袋
      },
      loadBoxOptions: [
        {
          name: this.$t("running.suspended1"),
          value: "1",
        },
        {
          name: this.$t("running.suspended0"),
          value: "0",
        },
      ],
      fbaOptions: [
        {
          label: this.$t("running.suspended0"),
          value: "1",
        },
        {
          label: "FBA",
          value: "0",
        },
        {
          label: "YFF",
          value: "2",
        },
        {
          label: "ZOZO",
          value: "3",
        },
        {
          label: "RSL",
          value: "4",
        },
      ],
      putIntentOption: [
        {
          name: this.$t("createOrder.createOrder58"),
          value: "0",
        },
        {
          name: this.$t("createOrder.createOrder59"),
          value: "1",
        },
        {
          name: this.$t("createOrder.createOrder60"),
          value: "2",
        },
        {
          name: this.$t("createOrder.createOrder61"),
          value: "3",
        },
      ],
      aliyunOssToken: {},
      ShowImg: false,
      showImgUrl: "",
    };
  },
  components: { editBreadcrumb, PriceInput },
  methods: {
    updateOrderInfo(value) {
      let data = {
        ...this.orderInfo,
        configCheckProjectArray:this.orderInfo.configCheckProjectArray.toString(),
        checkVideo: (this.orderInfo.checkVideoList || []).join(','),
        checkPhoto: (this.orderInfo.checkImageList || []).join(','),
      }
      this.$http.post(
          "order/updateOrderInfo",
          data
      ).then(res=>{
        if(res.code === 200){
          this.$message.success(res.message);
        }
      })
    },
    getVideo(str) {
      if (str != null && str.length > 0) {
        return str.split(",");
      }
      return [];
    },
    imgclick() {
      this.visible = true;
    },
    // 上传图片
    uploadImg(file) {
      let _self = this;
      const isJPG =
          file.file.type === "image/jpeg" || "image/jpg" || "image/png";
      if (!isJPG) {
        _self.$message.error(this.$t("createOrder.createOrder74"));
        return false;
      }
      let formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("modular", "createOrder");
      formdata.append("fileType", "");
      _self.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          _self.orderInfo.pictureUrl = res.data.data;
          // _self.addFormInfo.tableData[this.curRowImg].pictureUrl = res.data.data;
          // _self.addFormInfo.tableData[this.curRowImg].pictureName = res.data.data.split('createOrder/')[1];
          _self.$message.success(this.$t("createOrder.createOrder73"));
        } else {
          _self.$message.error(this.$t("createOrder.createOrder75"));
        }
      });
    },
    // 删除
    async delImg() {
      var _this = this;
      this.$confirm(this.$t("createOrder.createOrder71"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
          .then(() => {
            _this.orderInfo.pictureUrl = "";
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("createOrder.createOrder70"),
            });
          });
    },
    //检品选项
    configCheckChanged() {
      if (this.orderInfo.configCheckProjectArray.length > 0) {
        if (
            this.orderInfo.configCheckProjectArray &&
            this.orderInfo.configCheckProjectArray.indexOf("laundryLabel") > -1
        ) {
          this.isDisabled = false;
          this.addFormInfo.laundryLabelId[0].required = true;
        } else {
          this.addFormInfo.laundryLabelId[0].required = false;
          this.orderInfo.laundryLabelId = "";
          this.isDisabled = true;
        }
      } else {
        this.addFormInfo.laundryLabelId[0].required = false;
        this.orderInfo.laundryLabelId = "";
        this.isDisabled = true;
      }
    },
    //选择是否fba
    isFbaChange(val) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.addForm.clearValidate();
      });
      if (val == 1) {
        this.addFormInfo.fnsku[0].required = false;
        this.addFormInfo.goodsNameCus[0].required = false;
        this.addFormInfo.goodsName[0].required = false;
        this.orderInfo.fnsku = "";
        this.orderInfo.goodsNameCus = "";
        this.isFbaDisabled = true;
      } else {
        this.addFormInfo.fnsku[0].required = true;
        this.addFormInfo.goodsNameCus[0].required = true;
        this.addFormInfo.goodsName[0].required = false;
        this.isFbaDisabled = false;
      }
      if (val == 1) {
        this.addFormInfo.skuLabel = "バーコード";
        this.$set(this.addFormInfo, "skuLabel", "バーコード");
        this.addFormInfo.skuPlaceolder = "";
        this.$set(this.addFormInfo, "skuPlaceolder", "");
      }
      if (val == 0) {
        this.addFormInfo.skuLabel = "FNSKU";
        this.addFormInfo.skuPlaceolder = "X00000001";
        this.$set(this.addFormInfo, "skuPlaceolder", "X00000001");
        this.$set(this.addFormInfo, "skuLabel", "FNSKU");
      }
      if (val == 2) {
        this.addFormInfo.skuLabel = "検品コード※商品バーコード情報";
        this.addFormInfo.skuPlaceolder = "hello-red";
        this.$set(this.addFormInfo, "skuPlaceolder", "hello-red");
        this.$set(this.addFormInfo, "skuLabel", "検品コード※商品バーコード情報");
      }
      if (val == 3) {
        this.addFormInfo.skuLabel = "ZOZOバーコード";
        this.addFormInfo.skuPlaceolder = "ICH123456789";
        this.$set(this.addFormInfo, "skuPlaceolder", "ICH123456789");
        this.$set(this.addFormInfo, "skuLabel", "ZOZOバーコード");
      }
      if (val == 4) {
        this.addFormInfo.skuLabel = "RSLバーコード";
        this.addFormInfo.skuPlaceolder = "123456789";
        this.$set(this.addFormInfo, "skuPlaceolder", "123456789");
        this.$set(this.addFormInfo, "skuLabel", "RSLバーコード");
      }
    },
    //选择是否代购
    isAgentChange(val) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.addForm.clearValidate();
      });
      if (val == "0") {
        //fba
        //需要给对象内每个属性动态赋值
        this.addFormInfo.fnsku[0].required = false;
        this.addFormInfo.goodsName[0].required = false;
        this.addFormInfo.sender[0].required = false;
        this.addFormInfo.senderPhone[0].required = false;
        this.addFormInfo.sendAddress[0].required = false;
        this.addFormInfo.receiver[0].required = false;
        this.addFormInfo.receiverPhone[0].required = false;
        this.addFormInfo.zipCode[0].required = false;
        this.addFormInfo.receiverAddress[0].required = false;
        this.addFormInfo.trackingNumberCn[0].required = true;
        this.addFormInfo.chineseFreightFee[0].required = false;
        this.isAgentDisabled = false;
        this.orderInfo.chineseFreightFee = 0;
      } else {
        this.addFormInfo.fnsku[0].required = false;
        this.addFormInfo.goodsName[0].required = false;
        this.addFormInfo.sender[0].required = true;
        this.addFormInfo.senderPhone[0].required = true;
        this.addFormInfo.sendAddress[0].required = true;
        this.addFormInfo.receiver[0].required = true;
        this.addFormInfo.receiverPhone[0].required = true;
        this.addFormInfo.zipCode[0].required = true;
        this.addFormInfo.receiverAddress[0].required = true;
        this.addFormInfo.trackingNumberCn[0].required = false;
        this.addFormInfo.chineseFreightFee[0].required = true;
        this.isAgentDisabled = true;
        this.orderInfo.trackingNumberCn = "";
      }
    },
    //选择是否fba
    orderTypeChange(val, index) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.addForm.clearValidate();
      });
      if (val == "0") {
        //fba
        //需要给对象内每个属性动态赋值
        this.addFormInfo.fnsku[0].required = true;
        this.addFormInfo.goodsName[0].required = true;
        this.addFormInfo.sender[0].required = false;
        this.addFormInfo.senderPhone[0].required = false;
        // this.addFormInfo..senderPhone[1].validator=checkNone;
        this.addFormInfo.sendAddress[0].required = false;
        this.addFormInfo.receiver[0].required = false;
        this.addFormInfo.receiverPhone[0].required = false;
        // this.addFormInfo..receiverPhone[1].validator=checkNone;
        this.addFormInfo.zipCode[0].required = false;
        this.addFormInfo.receiverAddress[0].required = false;
        if (index == 1) {
          this.addFormInfo.fnsku[0].required = false;
        }
      } else {
        this.addFormInfo.fnsku[0].required = false;
        this.addFormInfo.goodsName[0].required = false;
        this.addFormInfo.sender[0].required = true;
        this.addFormInfo.senderPhone[0].required = true;
        // this.addFormInfo..senderPhone[1].validator=checkPhone;
        this.addFormInfo.sendAddress[0].required = true;
        this.addFormInfo.receiver[0].required = true;
        this.addFormInfo.receiverPhone[0].required = true;
        // this.addFormInfo..receiverPhone[1].validator=checkPhone;
        this.addFormInfo.zipCode[0].required = true;
        this.addFormInfo.receiverAddress[0].required = true;
      }
    },

    imgView(url) {
      this.ShowImg = !this.ShowImg;
      this.showImgUrl = url;
    },
    delPdf() {
      let _this = this;
      this.$confirm(this.$t("createOrder.createOrder68"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
          .then(() => {
            let formdata = new FormData();
            formdata.append("fileUrl", this.orderInfo.pdfUrl);
            this.$http.post("aliyun/oss/delFile", formdata).then((res) => {
              if (res.data.code == 200) {
                _this.$message({
                  type: "success",
                  message: res.data.message,
                });
                _this.orderInfo.pdfName = "";
                _this.orderInfo.pdfUrl = "";
              } else {
                _this.$message({
                  type: "error",
                  message: res.data.message,
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("createOrder.createOrder70"),
            });
          });
    },
    delFile() {
      let _this = this;
      this.$confirm(this.$t("createOrder.createOrder68"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
          .then(() => {
            let formdata = new FormData();
            formdata.append("fileUrl", this.orderInfo.inspectionFileUrl);
            this.$http.post("aliyun/oss/delFile", formdata).then((res) => {
              if (res.data.code == 200) {
                _this.$message({
                  type: "success",
                  message: res.data.message,
                });
                _this.orderInfo.inspectionFileName = "";
                _this.orderInfo.inspectionFileUrl = "";
              } else {
                _this.$message({
                  type: "error",
                  message: res.data.message,
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("createOrder.createOrder70"),
            });
          });
    },
    downloadPdf(name, url) {
      let formdata = new FormData();
      formdata.append("FileUrl", url);
      formdata.append("FileName", name);
      this.$http({
        url: "aliyun/oss/download",
        method: "post",
        data: formdata,
        responseType: "blob", //关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "" }); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", name); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    downloadFile(name, url) {
      let formdata = new FormData();
      formdata.append("FileUrl", url);
      formdata.append("FileName", name);
      this.$http({
        url: "aliyun/oss/download",
        method: "post",
        data: formdata,
        responseType: "blob", //关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "" }); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", name); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    uploadVideo(file) {
      let _self = this;
      const fileSuffix = file.file.name.substring(
          file.file.name.lastIndexOf(".") + 1
      ).toLowerCase();
      const whiteList = ["pdf", "ai"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$message.error('上传文件只能是 pdf、ai 格式');
        _self.$message.error(this.$t("createOrder.createOrder98"));
        return;
      }
      const isLt2M = file.file.size / 1024 / 1024 < 20;

      if (!isLt2M) {
        // this.$message.error('上传文件大小不能超过 20MB');
        _self.$message.error(this.$t("createOrder.createOrder97"));
        return;
      }
      // let _self = this;
      // const isPDF = file.file.type === "application/pdf";
      // if (!isPDF) {
      //     _self.$message.error(this.$t('createOrder.createOrder72'));
      //     return;
      // }
      let formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("modular", "OrderDetail");
      formdata.append("type", "");
      _self.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          _self.orderInfo.pdfUrl = res.data.data;
          _self.orderInfo.pdfName = res.data.data.split("OrderDetail/")[1];
          _self.$message.success(this.$t("createOrder.createOrder73"));
        }
      });
      // var _self = this;
      // await this.getOssKey();
      // //key就代表文件层级和阿里云上的文件名
      // //         accessKeyId: "LTAI4G7SvxAdnGS3s3f9UA7K"
      // // callback: "eyJjYWxsYmFja0JvZHlUeXBlIjoiYXBwbGljYXRpb24veC13d3ctZm9ybS11cmxlbmNvZGVkIiwiY2FsbGJhY2tVcmwiOiJodHRwOi8vbG9jYWxob3N0OjgwODEvYWxpeXVuL29zcy9jYWxsYmFjayIsImNhbGxiYWNrQm9keSI6ImZpbGVuYW1lPSR7b2JqZWN0fSZzaXplPSR7c2l6ZX0mbWltZVR5cGU9JHttaW1lVHlwZX0maGVpZ2h0PSR7aW1hZ2VJbmZvLmhlaWdodH0md2lkdGg9JHtpbWFnZUluZm8ud2lkdGh9In0="
      // // dir: "test/oytqc/images/20210413"
      // // host: "http://oytqc-oss.oss-cn-qingdao.aliyuncs.com"
      // // policy: "eyJleHBpcmF0aW9uIjoiMjAyMS0wNC0xM1QwMzoxODoyNi44NzBaIiwiY29uZGl0aW9ucyI6W1siY29udGVudC1sZW5ndGgtcmFuZ2UiLDAsMTA0ODU3NjBdLFsic3RhcnRzLXdpdGgiLCIka2V5IiwidGVzdC9veXRxYy9pbWFnZXMvMjAyMTA0MTMiXV19"
      // // signature: "306UKSf9zW+h+dbty+qytCjEY6E="

      // let imgType = file.file.type.split("/")[1];
      // let filename = file.file.name + file.file.size; //md5对图片名称进行加密
      // // let keyValue = "images/" + md5(new Date() + filename) + "." + imgType;
      // // 组装formdata
      // let formdata = new FormData();
      // formdata.append('name', 'order/'+ file.file.name)
      // // formdata.append('key', keyValue)
      // formdata.append('policy', _self.aliyunOssToken.policy)
      // formdata.append('OSSAccessKeyId', _self.aliyunOssToken.accessKeyId)
      // formdata.append('success_action_status', 200)
      // formdata.append('signature', _self.aliyunOssToken.signature)
      // formdata.append('file', file.file)

      // _self.uploadOSS(formdata,_self.aliyunOssToken.host).then(function(res){
      //     // _self.form.cover = _self.aliyunOssToken.host + '/' + keyValue;
      //     _self.$message.success('上传成功');
      //     this.orderInfo.pdfUrl= _self.aliyunOssToken.host + '/order/' + file.file.name;

      // }).catch(function(error){
      //     _self.$message.error('上传失败');
      // })
    },
    //上传检品文件
    uploadFile(file) {
      let _self = this;
      const fileSuffix = file.file.name.substring(
          file.file.name.lastIndexOf(".") + 1
      ).toLowerCase();
      const whiteList = [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "pdf",
        "txt",
        "jpg",
        "jpeg",
        "png",
        "gif",
      ];
      if (whiteList.indexOf(fileSuffix) === -1) {
        _self.$message.error(this.$t("createOrder.createOrder96"));
        return;
      }
      const isLt2M = file.file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        _self.$message.error(this.$t("createOrder.createOrder97"));
        return;
      }
      let formdata = new FormData();
      formdata.append("file", file.file);
      formdata.append("modular", "OrderDetail");
      formdata.append("fileType", "");
      _self.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          _self.orderInfo.inspectionFileUrl = res.data.data;
          _self.orderInfo.inspectionFileName =
              res.data.data.split("OrderDetail/")[1];
          _self.$message.success(this.$t("createOrder.createOrder73"));
        }
      });
    },
    uploadOSS(formData, url) {
      // const config = {
      //   headers: { "Content-Type": "multipart/form-data;boundary="+new Date().getTime() }
      //   };
      return axios.post(url, formData);
    },
    async getOssKey() {
      const { data: res } = await this.$http.get("aliyun/oss/policy");
      this.aliyunOssToken = res.data;
    },
    async getOrderDetail() {
      const { data: res } = await this.$http.get("order/" + this.orderId);
      this.orderInfo = res.data;
      this.hisOrderStateLogList = res.data?.hisOrderStateLogList;
      if (res.data.checkVideo) {
        this.orderInfo.checkVideoList = res.data.checkVideo.split(',').filter((url) => url);
      } else {
        this.orderInfo.checkVideoList = [];
      }
      if (res.data.checkPhoto) {
        this.orderInfo.checkImageList = res.data.checkPhoto.split(',').filter((url) => url);
      } else {
        this.orderInfo.checkImageList = [];
      }
      this.orderTypeChange(res.data.orderType);
      //代购单 orderStatus为代购买时商品不能编辑
      //对于国内订单号 是代购单的情况下任何状态都不能编辑
      if (res.data.agentFlag == "1") {
        if (res.data.orderStatus == "1") {
          this.goodsEditFlag = false;
        } else {
          this.goodsEditFlag = true;
        }
        this.chinaOrderFlag = true;
      }
      //非代购单 orderStatus为等待倒库时商品不能编辑
      if (res.data.agentFlag == "0") {
        if (res.data.orderStatus == "0") {
          this.goodsEditFlag = false;
        } else {
          this.goodsEditFlag = true;
        }
        this.chinaOrderFlag = false;
      }
      //字符串转数组
      if (
          this.orderInfo.configCheckProjectArray &&
          this.orderInfo.configCheckProjectArray.length > 0
      ) {
        this.orderInfo.configCheckProjectArray =
            this.orderInfo.configCheckProjectArray.split(",");
      }
      if (
          this.orderInfo.configCheckProjectArray &&
          this.orderInfo.configCheckProjectArray.indexOf("laundryLabel") > -1
      ) {
        this.isDisabled = false;
        this.addFormInfo.laundryLabelId[0].required = true;
      } else {
        this.orderInfo.laundryLabelId = "";
        this.isDisabled = true;
        this.addFormInfo.laundryLabelId[0].required = false;
      }
      //是否fba初始化
      //   if (res.data.orderType == '0') {
      //     this.addFormInfo.fnsku[0].required = true;
      //     this.addFormInfo.goodsNameCus[0].required = true;
      //     this.isFbaDisabled = false;
      //   } else {
      //     this.addFormInfo.fnsku[0].required = false;
      //     this.addFormInfo.goodsNameCus[0].required = false;
      //     this.isFbaDisabled = true;
      //     this.orderInfo.fnsku = "";
      //     this.orderInfo.goodsNameCus = "";
      //   }
      if (res.data.orderType == 1) {
        this.addFormInfo.fnsku[0].required = false;
        this.addFormInfo.goodsNameCus[0].required = false;
        this.isFbaDisabled = true;
        this.orderInfo.fnsku = "";
        this.orderInfo.goodsNameCus = "";
      } else {
        this.addFormInfo.fnsku[0].required = true;
        this.addFormInfo.goodsNameCus[0].required = true;
        this.isFbaDisabled = false;
      }
      if (res.data.orderType == 1) {
        this.addFormInfo.skuLabel = "バーコード";
        this.$set(this.addFormInfo, "skuLabel", "バーコード");
        this.addFormInfo.skuPlaceolder = "";
        this.$set(this.addFormInfo, "skuPlaceolder", "");
      }
      if (res.data.orderType == 0) {
        this.addFormInfo.skuLabel = "FNSKU";
        this.addFormInfo.skuPlaceolder = "X00000001";
        this.$set(this.addFormInfo, "skuPlaceolder", "X00000001");
        this.$set(this.addFormInfo, "skuLabel", "FNSKU");
      }
      if (res.data.orderType == 2) {
        this.addFormInfo.skuLabel = "検品コード※商品バーコード情報";
        this.addFormInfo.skuPlaceolder = "hello-red";
        this.$set(this.addFormInfo, "skuPlaceolder", "hello-red");
        this.$set(this.addFormInfo, "skuLabel", "検品コード※商品バーコード情報");
      }
      if (res.data.orderType == 3) {
        this.addFormInfo.skuLabel = "ZOZOバーコード";
        this.addFormInfo.skuPlaceolder = "ICH123456789";
        this.$set(this.addFormInfo, "skuPlaceolder", "ICH123456789");
        this.$set(this.addFormInfo, "skuLabel", "ZOZOバーコード");
      }
      if (res.data.orderType == 4) {
        this.addFormInfo.skuLabel = "RSLバーコード";
        this.addFormInfo.skuPlaceolder = "123456789";
        this.$set(this.addFormInfo, "skuPlaceolder", "123456789");
        this.$set(this.addFormInfo, "skuLabel", "RSLバーコード");
      }
      //是否代购初始化
      if (res.data.agentFlag == "0") {
        this.addFormInfo.trackingNumberCn[0].required = true;
        this.addFormInfo.chineseFreightFee[0].required = false;
        this.isAgentDisabled = false;
        this.orderInfo.chineseFreightFee = 0;
      } else {
        this.addFormInfo.trackingNumberCn[0].required = false;
        this.addFormInfo.chineseFreightFee[0].required = true;
        this.isAgentDisabled = true;
        this.orderInfo.trackingNumberCn = "";
      }
    },
    async getLaundryLabel() {
      const { data: res } = await this.$http.get(
          "laundry/label/template/getAllByCustomerId/" + this.customerId
      );
      this.laundryLabelOption = res.data;
    },
    async getConfigLists() {
      const { data: res } = await this.$http.get(
          "order/getOrderInfoConfigList"
      );
      this.configLists = res.data;
      //如果客户拥有特殊检品选项，则查询合并
      if (
          this.orderInfo.inspectOption != null &&
          this.orderInfo.inspectOption != ""
      ) {
        const { data: res } = await this.$http.get("/order/getNameList", {
          params: {
            inspectOption: this.orderInfo.inspectOption,
            isPrivate: "1",
          },
        });
        if (res.data != null && res.data.length > 0) {
          let inspectionConfigList = res.data.map((item) => {
            return {
              name: item.name,
              value: item.nameCd,
            };
          });
          this.configLists.inspectionConfigList =
              this.configLists.inspectionConfigList.concat(inspectionConfigList);
        }
      }
    },
    async savePost() {
      if (
          this.orderInfo.configCheckProjectArray &&
          this.orderInfo.configCheckProjectArray.length > 0
      ) {
        this.orderInfo.configCheckProjectArray =
            this.orderInfo.configCheckProjectArray.join(",");
      } else {
        this.orderInfo.configCheckProjectArray = "";
      }
      this.orderInfo.checkVideo = (this.orderInfo.checkVideoList || []).join(',');
      this.orderInfo.checkPhoto = (this.orderInfo.checkImageList || []).join(',');
      const { data: res } = await this.$http.post(
          "order/updateOrderInfo",
          this.orderInfo
      );
      if (res.code == 200) {
        this.$message.success(res.message);
        this.$router.go(-1);
      } else {
        this.$message.error(res.message);
      }
    },
    async cancelEditOrder() {
      await this.getOrderDetail();
      this.$router.go(-1);
    },
    saveEditOrder() {
      var _this = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this.savePost();
        } else {
          _this.$message.error(this.$t("OrderDetail.OrderDetail45"));
        }
      });
    },
  },
  created() {
    this.orderId = this.$route.query.id;
    this.customerId = this.$route.query.customerId;
    this.isEditPage = this.$route.query.isEdit == "0" ? false : true;
    this.pageTitle =
        this.isEditPage == "0"
            ? this.$t("OrderDetail.OrderDetail41")
            : this.$t("OrderDetail.OrderDetail46");
    this.getOrderDetail();
    this.getLaundryLabel();
    this.getConfigLists();
  },
  computed: {
    editOrderInfo() {
      if (
          this.isEditPage &&
          (this.orderInfo.orderStatus == 1 ||
              this.orderInfo.orderStatus == 12 ||
              this.orderInfo.orderStatus == 2 ||
              this.orderInfo.orderStatus == 0 ||
              this.orderInfo.orderStatus == 4 ||
              this.orderInfo.orderStatus == 8)
      ) {
        return true;
      } else {
        return false;
      }
    },
    editGoodsInfo() {
      if (
          this.isEditPage &&
          (this.orderInfo.orderStatus == 1 ||
              this.orderInfo.orderStatus == 12 ||
              this.orderInfo.orderStatus == 2 ||
              this.orderInfo.orderStatus == 0 ||
              this.orderInfo.orderStatus == 4 ||
              this.orderInfo.orderStatus == 8)
      ) {
        return true;
      } else {
        return false;
      }
    },
    editOrderInfoAccountNumber() {
      return true;
      // if (
      //     this.isEditPage &&
      //     ((this.orderInfo.orderStatus == 1 &&
      //         this.orderInfo.agentFlag == 1) ||
      //         (this.orderInfo.orderStatus == 0 &&
      //             this.orderInfo.agentFlag == 0))
      // ) {
      //     return true;
      // } else {
      //     return false;
      // }
    },
    editAddressInfo() {
      if (
          this.isEditPage &&
          (this.orderInfo.orderStatus == 0 ||
              this.orderInfo.orderStatus == 1 ||
              this.orderInfo.orderStatus == 2 ||
              this.orderInfo.orderStatus == 4 ||
              this.orderInfo.orderStatus == 8 ||
              this.orderInfo.orderStatus == 12 ||
              this.orderInfo.orderStatus == 16 ||
              (this.orderInfo.orderStatus == 24) |
              (this.orderInfo.orderStatus == 26) ||
              this.orderInfo.orderStatus == 28 ||
              this.orderInfo.orderStatus == 32 ||
              this.orderInfo.orderStatus == 36 ||
              this.orderInfo.orderStatus == 82 ||
              this.orderInfo.orderStatus == 40 ||
              this.orderInfo.orderStatus == 60 ||
              this.orderInfo.orderStatus == 76)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
///deep/ .el-col{
//  min-height:60px;
//  padding:10px 0;
//  //  border:1px solid red;
//}
/deep/ .hidden {
  overflow: hidden !important;
}

/deep/ .el-form-item__error {
  top: 17% !important;
  left: 91% !important;
  width: 24px !important;
}

/deep/ .l87 .el-form-item__error {
  left: 87% !important;
}

/deep/ .nomove .el-form-item__error {
  top: 20% !important;
  left: 53% !important;
  width: 48% !important;
}

.order-detail-container {
  background: #fff;
}

ul,
li {
  list-style: none;
}

.table-title {
  padding: 5px;
  text-align: left;
  background: rgb(245, 246, 248);
  color: #606266;
  font-weight: 700;
}

.table-content {
  border-right: 1px solid #d8d8e0;
}

.table-content .content .el-col {
  height: 37px;
  line-height: 30px;
  padding: 0 2px;
  border-left: 1px solid #d8d8e0;
  border-bottom: 1px solid #d8d8e0;
  text-align: left;
  // white-space:nowrap;
  // text-overflow:ellipsis;
  word-wrap: break-word;
  word-break: normal;
  overflow: auto;
}

.el-form-item {
  margin-bottom: 0 !important;
}

/deep/ .el-form-item__content {
  line-height: 30px !important;
}

// .table-content .content{
//   padding-bottom: 10px;
// }
.order-detail-page /deep/ .el-input {
  width: 98% !important;
}

.save-btn-container {
  padding-top: 10px;
  padding-right: 10px;
  text-align: right;
}

.tabel-container {
  margin-top: 10px;
}

.tabel-container-top {
  margin-top: 0;
}

.btnn {
  margin-top: 6px;
  margin-left: 10px !important;
}

.bt {
  margin-top: 6px;
}

.check-video {
  border: 1px solid #e5e9f8;
  text-align: left;

  video {
    margin: 20px;
  }
}
</style>
